import { REQUEST } from '@/constants/api';

import { PEPAnswer, PEPQuestion } from '@/types/api/pep';

import { axios } from './axios';

export const getPEPQuestions = async () => {
  const result = await axios.get<PEPQuestion[]>(REQUEST.PEP.QUESTIONS);

  return result.data;
};

export const addAnswer = async ({
  answer,
  previousAnswers,
  answerId,
}: {
  answer: PEPAnswer;
  previousAnswers: PEPAnswer[];
  answerId?: string;
}) => {
  if (!answerId) {
    const result = await axios.post(REQUEST.PEP.QUESTIONS, {
      answers: [answer],
    });
    return result.data;
  }

  const result = await axios.put(REQUEST.PEP.QUESTION_BY_ANSWER_ID(answerId), {
    answers: [...previousAnswers, answer],
  });
  return result.data;
};
